
/**
 * Password validation utility
 * Checks if a password meets the following requirements:
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 * - At least one special character
 */

export function validatePassword(password: string): { 
  isValid: boolean; 
  errorMessage: string;
} {
  // Check for minimum length (8 characters is a good standard)
  if (password.length < 8) {
    return {
      isValid: false,
      errorMessage: "Password must be at least 8 characters long"
    };
  }

  // Check for uppercase letter
  if (!/[A-Z]/.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must include at least one uppercase letter"
    };
  }

  // Check for lowercase letter
  if (!/[a-z]/.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must include at least one lowercase letter"
    };
  }

  // Check for number
  if (!/[0-9]/.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must include at least one number"
    };
  }

  // Check for special character - simplified and more reliable pattern
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must include at least one special character (e.g., !@#$%^&*)"
    };
  }

  // All checks passed
  return {
    isValid: true,
    errorMessage: ""
  };
}
